/* eslint-disable @scandipwa/scandipwa-guidelines/jsx-no-props-destruction */
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import SubscriptionQuery from 'Query/Subscription.query';
import { updateCustomerDetails } from 'Store/MyAccount/MyAccount.action';
import { CustomerType } from 'Type/Account.type';
import { fetchMutation } from 'Util/Request';

import SubscriptionPopupFormComponent from './SubscriptionPopupForm.component';

/** @namespace Scandipwa/Component/SubscriptionPopupForm/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    updateCustomer: (customer) => (dispatch(updateCustomerDetails(customer)))
});

/** @namespace Scandipwa/Component/SubscriptionPopupForm/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    subscriptionPopupHeading: state.ConfigReducer.subscriptionPopupHeading,
    subscriptionPopupCta: state.ConfigReducer.subscriptionPopupCta,
    subscriptionPopupTerms: state.ConfigReducer.subscriptionPopupTerms,
    subscriptionPopupButton: state.ConfigReducer.subscriptionPopupButton,
    customer: state.MyAccountReducer.customer,
    isSignedIn: state.MyAccountReducer.isSignedIn
});

/** @namespace Scandipwa/Component/SubscriptionPopupForm/Container */
export class SubscriptionPopupFormContainer extends PureComponent {
    static propTypes = {
        subscriptionPopupButton: PropTypes.string.isRequired,
        subscriptionPopupCta: PropTypes.string.isRequired,
        subscriptionPopupHeading: PropTypes.string.isRequired,
        subscriptionPopupTerms: PropTypes.string.isRequired,
        customer: CustomerType.isRequired,
        isSignedIn: PropTypes.bool.isRequired,
        updateCustomer: PropTypes.func.isRequired
    };

    containerFunctions = {
        subscribe: this.subscribe.bind(this)
    };

    containerProps() {
        const {
            subscriptionPopupButton,
            subscriptionPopupCta,
            subscriptionPopupHeading,
            subscriptionPopupTerms,
            customer,
            isSignedIn
        } = this.props;

        return {
            subscriptionPopupButton,
            subscriptionPopupCta,
            subscriptionPopupHeading,
            subscriptionPopupTerms,
            customer,
            isSignedIn
        };
    }

    subscribe(email, gender, dob = null, response) {
        const requestField = SubscriptionQuery.getSubscriptionGenderBirthdayQueary(email, gender, dob);
        const {
            customer = {},
            customer: { email: customerEmail },
            isSignedIn,
            updateCustomer
        } = this.props;

        fetchMutation(requestField).then(
            /** @namespace Scandipwa/Component/SubscriptionPopupForm/Container/SubscriptionPopupFormContainer/subscribe/fetchMutation/then */
            ({ addGenderBirthdateToSubscription }) => {
                if (isSignedIn && email === customerEmail) {
                    updateCustomer({ ...customer, is_subscribed: true });
                }

                response(addGenderBirthdateToSubscription);
            },
            /** @namespace Scandipwa/Component/SubscriptionPopupForm/Container/SubscriptionPopupFormContainer/subscribe/fetchMutation/then/catch */
            ([{ message }]) => {
                response(message);
            }
        );
    }

    render() {
        return (
            <SubscriptionPopupFormComponent
              { ...this.containerProps() }
              { ...this.containerFunctions }
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SubscriptionPopupFormContainer);
